import api from "./apis";
import { ERROR_MESSAGE, LOADED, LOADING, SUCCESS_MESSAGE, VALIDATION_ERROR } from "./types";
import history from "../history";
export const getBatch = (p,e,a,b,ds,de) => async (dispatch) => {
 
    dispatch({ type: LOADING });

    try{
      let response = null;
        response = await api(localStorage.getItem("token")).get(`/code-management/batch?p=${p?p:1}&client=${e?e:""}&active=${a?a:""}&batch=${b?b:""}&ds=${ds?ds:""}&de=${de?de:""}`);
        // console.log(response)
      if(response.status === 200 ) {
        dispatch({ type: LOADED });
        return response.data;
        
      }
    }
    catch( err ){
        /* =============Start========== */
          if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }
          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
          dispatch({type: LOADED});
        /* ===========End============*/
      }
  }
export const getCode = (p,e,bo,b,ds,de,c) => async (dispatch) => {
 
    dispatch({ type: LOADING });
    

    try{
      let response = null;
        response = await api(localStorage.getItem("token")).get(`code-management/code?p=${p?p:1}&client=${e?e:""}&block=${bo?bo:""}&batch=${b?b:""}&ds=${ds?ds:""}&de=${de?de:""}&code=${c?encodeURIComponent(c):""}`);

        if(response.status === 200 ) {
        dispatch({ type: LOADED });
        return response.data;
        
      }
    }
    catch( err ){
        /* =============Start========== */
          if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }
          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
          dispatch({type: LOADED});
        /* ===========End============*/
      }
  }

  export const getCodeDetails = (id) => async (dispatch) => {
    dispatch({ type: LOADING });
    try{

      const response = await api(localStorage.getItem("token")).get( `/code-management/code/detail?code=${encodeURIComponent(id)}` );
      // console.log(response)
      if(response.status === 200 ) {
        dispatch({ type: LOADED });
        return response?.data;
      }
    }
    catch( err ){
        /* =============Start========== */
          if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }
          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
          dispatch({type: LOADED});
        /* ===========End============*/
      }
  }


  export const getBatchDetails = (id) => async (dispatch) => {
    dispatch({ type: LOADING });
    try{
      
      const response = await api(localStorage.getItem("token")).get(`/code-management/batch/detail?batch=${id}`);
    
      if(response.status === 200 ) {
        dispatch({ type: LOADED });
        return response?.data;
      }
    }
    catch( err ){
        /* =============Start========== */
          if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }
          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
          dispatch({type: LOADED});
        /* ===========End============*/
      }
  }

  export const updateBatchActive = (data,id) => async (dispatch) => {
    dispatch({ type: LOADING });
    try {
  
  
      const obj = {
        batch: data[0],
        active: data[1],
        remark: id.remark,
        
        
      }
      const response = await api(localStorage.getItem("token")).patch("/code-management/batch/block", {...obj});
  

      if (response.status === 201) {
        dispatch({
          type: SUCCESS_MESSAGE,
          payload: "Operation successful",
        });
        
        dispatch({ type: LOADED });
        return response.status
      } else {
        dispatch({ type: LOADED });
      }
    } catch (err) {
        /* =============Start========== */
          if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }
          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
          dispatch({type: LOADED});
        /* ===========End============*/
      }
  };
  export const updateCodeActive = (data,id) => async (dispatch) => {
    dispatch({ type: LOADING });
    try {
  
  // console.log(data,id)
      const obj = {
        code: data[0],
        active: data[1],
        remark: id.remark,
        
        
      }
      const response = await api(localStorage.getItem("token")).patch("/code-management/code/block", {...obj});
  // console.log(response)

      if (response.status === 201) {
        dispatch({
          type: SUCCESS_MESSAGE,
          payload: "Operation successful",
        });
        
        dispatch({ type: LOADED });
        return response.status
      } else {
        dispatch({ type: LOADED });
      }
    } catch (err) {
        /* =============Start========== */
          if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }
          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
          dispatch({type: LOADED});
        /* ===========End============*/
      }
  };


  export const updateScanLimit = ({scan_limit, remark,location_limit},code_id,type) => async (dispatch) => {

    dispatch({ type: LOADING });

    // console.log(scan_limit, remark, " Hello hunny bunny");

    const obj = {
      code: code_id,
      limit: scan_limit,
      remark: remark,
      type: type,
      location_limit: location_limit
      
      
    }
    dispatch({type: LOADED});
    try {
  
      const response = await api(localStorage.getItem("token")).patch("/code-management/code/limit/update", {...obj});
        // console.log(response)
      if (response.status === 201) {
        
        dispatch({type: LOADED});
        dispatch({type: SUCCESS_MESSAGE,payload: "Succesfully updated"});
        
        return response.status;
        }
    } catch (err) {
        /* =============Start========== */
          if(err?.response?.status === 422){
            err.response.data.errors.map(item => {
                dispatch({ type: VALIDATION_ERROR, payload: [{'message': item.message,'path':item.path[0]}]});
            })
          }
          if(err?.response?.status === 401 || err?.response?.status === 403 ){
              dispatch({ type: ERROR_MESSAGE, payload: err.response.data.message})
              localStorage.clear();
              history.push('/login')
          }
          dispatch({ type: ERROR_MESSAGE, payload: err.response ? err.response.data.message : history.push('/opps') });
          dispatch({type: LOADED});
        /* ===========End============*/
      }
  };
  